module.exports = __webpack_public_path__ + "img/new users.ff11c867.svg";